<template>
    <StepWrapper v-if="isActiveStep(step)" :step="step">

        <decorfinder v-if="getPossibleResults.length > 0" :base-products="getPossibleResults" mode="inline" @change="onDecorSelection" />

        <div class="button-wrapper spacer--top-small spaced">
            <GlobalButton theme="secondary" @click="back">{{ $t('decor.button.back') }}</GlobalButton>
            <GlobalButton theme="primary" @click="next" :disabled="!hasDecorSelection">{{ $t('decor.button.next') }}</GlobalButton>
        </div>
    </StepWrapper>
</template>

<script lang="ts">
    import Vue from "vue";
    import {mapGetters, mapState} from "vuex";
    import {STEP} from "../store/solutionGuideStore"
    import StepWrapper from "./step-wrapper.vue";
    import GlobalButton from "../../../../../global/global-elements/global-button/global-button.vue";
    import Decorfinder from "./decorfinder.vue";
    import {Productfinder} from "../../../../../_types/productfinder";

	export default Vue.extend({
        name: "step-decor",
        components: {Decorfinder, GlobalButton, StepWrapper},
        data(): {
            step: STEP,
            decor: Productfinder.Product | null
        } {
            return {
                step: STEP.Decor,
                decor: null
            }
        },
        computed: {
            ...mapState(['component', 'result', 'activeStep', 'decorFinderConfig', 'decorFinderSelection', 'decorFinderPending']),
            ...mapGetters(['isActiveStep', 'selectedDecor', 'getPossibleResults']),
            hasDecorSelection(): boolean {
                return this.selectedDecor
            },
        },
        methods: {
            onDecorSelection(decor: Productfinder.Product) {
                // this.$store.commit('selectDecor', { key: this.component.name + '#' + this.result.pim_id, decor: decor})
                this.$store.commit('chooseDecor', { decor: decor})
            },
            back() {
                this.$store.commit('back')
            },
            next() {
                this.$store.commit('next')
            }
        }
    })
</script>
